import { jsx as _jsx } from "react/jsx-runtime";
/* Generated file. Do not modify. */
import { createElement } from 'react';
import { IconSvg } from '../../icons/IconSvg.js';
export const CheckIcon = (props) => createElement(IconSvg, {
    ...props,
    viewBox: "0 0 24 24"
}, _jsx("path", { d: "M21.5304 6.53033L20.4697 5.46967L9.00006 16.9393L3.53039 11.4697L2.46973 12.5303L9.00006 19.0607L21.5304 6.53033Z", fill: "currentColor" }));
//# sourceMappingURL=CheckIcon.js.map